/**
 * Pure market-resolution logic for useRegion, extracted so it can be unit-tested
 * without a DOM/React (the hook wraps this with URL params + localStorage).
 *
 * Resolution order — DELIBERATE:
 *   1. URL `?region=` (deep-link / shareable URL wins)
 *   2. the persisted per-brand choice (survives navigation that drops the param)
 *   3. the brand's primary market (default)
 * `?region=all` → null (All-markets, Overview only). A stored/url market that
 * isn't currently ACTIVE is ignored (falls through to primary) so a stale
 * persisted value can never strand a brand on a market it no longer has.
 *
 * Single-account brands: activeRegions has one entry and primary == it, so this
 * always returns that one market regardless of url/stored — behaviour is
 * identical to before persistence existed (no regression).
 */
export function resolveRegion(
  urlRegion: string | null,
  stored: string | null,
  activeRegions: string[],
  primary: string | null,
): string | null {
  const u = (urlRegion || "").toUpperCase();
  if (u === "ALL") return null; // explicit All countries (Overview only)
  if (u && activeRegions.includes(u)) return u; // URL param wins (deep-link)
  const s = (stored || "").toUpperCase();
  if (s && activeRegions.includes(s)) return s; // then the persisted choice
  return primary; // default = the brand's primary (single-market default)
}
